<h1 mat-dialog-title class="text-4xl text-center">{{title}}</h1>

<div mat-dialog-content class="text-center">
    <h4 class="text-2xl font-light my-1" *ngFor="let item of subtitles">{{item}}</h4>
</div>

<div mat-dialog-actions class="flex flex-0 items-center justify-end">
    <button mat-button class="text-primary-600" (click)="onClose()">OK</button>
</div>
